import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Folder, FilePlus, FileText, FlaskConical, BookOpen,
  Sparkles, ClipboardCheck, Stamp, Download, ScrollText, ShieldCheck, Settings,
  Building2,
} from "lucide-react";

const ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/cases", label: "Cases", icon: Folder },
  { to: "/cases/new", label: "Smart Intake", icon: FilePlus },
  { to: "/documents", label: "Documents", icon: FileText },
  { to: "/processing", label: "Processing Review", icon: FlaskConical },
  { to: "/knowledge", label: "Knowledge Base", icon: BookOpen },
  { to: "/draft", label: "Draft Generator", icon: Sparkles },
  { to: "/review", label: "Review Workspace", icon: ClipboardCheck },
  { to: "/approvals", label: "Approvals", icon: Stamp },
  { to: "/exports", label: "Exports", icon: Download },
  { to: "/audit", label: "Audit Logs", icon: ScrollText },
  { to: "/compliance", label: "Compliance", icon: ShieldCheck },
  { to: "/settings", label: "Settings", icon: Settings },
];

export default function Sidebar() {
  const { pathname } = useLocation();

  return (
    <aside className="ssrd-banner text-white w-64 shrink-0 hidden lg:flex flex-col h-screen sticky top-0">
      <div className="px-5 pt-5 pb-4 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="size-10 rounded-md bg-white/10 grid place-items-center border border-white/15">
            <Building2 className="size-5 text-blue-200" />
          </div>
          <div>
            <div className="text-[10px] tracking-widest text-blue-200 uppercase">Govt. of Gujarat</div>
            <div className="text-sm font-bold leading-tight">SSRD Drafting</div>
            <div className="text-[10px] text-blue-100/70">Remi8-Assisted, Officer-Approved</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto" data-testid="sidebar-nav">
        {ITEMS.map(({ to, label, icon: Icon }) => {
          const active = pathname === to || (to !== "/dashboard" && pathname.startsWith(to));
          return (
            <Link
              key={to}
              to={to}
              className={`nav-link ${active ? "active" : ""}`}
              data-testid={`nav-link-${to.replace(/[/\s]+/g, "-")}`}
            >
              <Icon className="size-4" />
              <span>{label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="px-5 py-3 border-t border-white/10">
        <div className="text-[10px] text-blue-100/70 leading-relaxed">
          Remi8 AI Engine · POC build
          <br/>India data residency · DPDP-aligned
        </div>
      </div>
    </aside>
  );
}
